'use client';

import { Grid2, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { icons } from '@/assets/icons';
import { backgrounds } from '@/assets/materials';
import { BUILD_WITH_US_URL, ORBIT_URL } from '@/global/configs/common';

import { ProductCard } from './ProductCard';
import HexagonalButton from './bases/HexagonalButton';

const PRODUCTS = [
  {
    id: 0,
    image: backgrounds.core_sales,
    highlightColor: '#FFCF40',
    name: 'Core Sale Program',
    desc: `A Core sale raises capital for blockchain projects while creating a sustainable decentralized network and reward community participation.\n\nLaunch and manage Core Sales with our end-to-end platform.`,
    buttonLabel: 'BUILD WITH US',
    href: BUILD_WITH_US_URL,
  },
  // {
  //   id: 1,
  //   image: undefined,
  //   highlightColor: '#0ACBE6',
  //   name: 'Unstoppable Domains',
  //   desc: `Simplify your identity across Web3. In partnership with Unstoppable Domains, replace your complex wallet addresses with a single Web3 username that works across apps, wallets, and dApps.\n\nTake control of your digital presence with a .LFG domain.`,
  //   buttonLabel: 'GET YOURS TODAY',
  //   href: 'https://get.unstoppabledomains.com/lfg',
  // },
  {
    id: 2,
    image: backgrounds.orbit_medal,
    highlightColor: '#FF4043',
    name: 'LFG Orbit',
    desc: `Orbit is a global workforce platform that enables companies to hire, pay, and manage employees and contractors worldwide without setting up local entities or managing complex compliance.\n\nBuild Your Global Team With Confidence.`,
    buttonLabel: 'LEARN MORE',
    href: ORBIT_URL,
  },
];

export const OurProductsSection = () => {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack padding={{ xs: '100px 24px 40px', sm: '80px' }} alignItems={'center'}>
        <Stack gap={{ xs: 3, sm: 7 }} width={'min(1280px, 100%)'} zIndex={2} alignItems={'center'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            textAlign={'center'}
            whiteSpace={'pre-line'}
            fontSize={{ xs: '24px', sm: '48px' }}
            lineHeight={{ xs: '32px', sm: '68px' }}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            OUR PRODUCTS
          </Typography>
          <Grid2 container spacing={3}>
            {PRODUCTS.map(item => (
              <Grid2 key={item.id} size={{ xs: 12, sm: 12 }}>
                <ProductCard highlightColor={item.highlightColor} name={item.name} decs={item.desc} image={item.image}>
                  {item.id === 1 ? (
                    <HexagonalButton
                      variant={'primary'}
                      label={item.buttonLabel}
                      width={219}
                      onClick={() => window.open(item.href, '_blank')}
                    />
                  ) : (
                    <HexagonalButton
                      variant={'secondary'}
                      label={item.buttonLabel}
                      width={219}
                      onClick={() => window.open(item.href, '_blank')}
                    />
                  )}
                </ProductCard>
              </Grid2>
            ))}
          </Grid2>
        </Stack>
      </Stack>
      <Stack zIndex={1} position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <Image src={icons.ic_wave_section} alt={''} layout={'fill'} objectFit={'cover'} />
      </Stack>
    </Stack>
  );
};
